export default {
  computed: {

    isHomePage() {

      return (this.$route.path === "/")
    },

    isMessagesPage() {

      return this.$route.path.startsWith("/messages")
    },

    isNotificationsPage() {

      return this.$route.path.startsWith("/notifications")
    },

    isProductsPage() {

      return this.$route.path.startsWith("/products")
    },

    isProductsSearchPage() {

      return this.$route.path.startsWith("/products/search")
    },

    isProductsReservesPage() {

      return this.$route.path.startsWith("/products/reserves")
    },

    isQuotationsPage() {

      return this.$route.path.startsWith("/quotations")
    },

    isCustomersPage() {

      return this.$route.path.startsWith("/customers")
    },

    isProfilePage() {

      return this.$route.path.startsWith("/profile")
    },

    isUseTermsPage() {

      return this.$route.path.startsWith("/use-terms")
    },
  }
}
